module.exports = __webpack_public_path__ + "static/analog-photo-6-c4c8890b73bfe9de62bf10654131b9da.jpg";